<template lang='pug'>
  v-card.elevation-12
    v-toolbar(dark, color="primary")
      v-toolbar-title ログイン
      v-spacer
    v-card-text.font-weight-bold.red--text.wrap(v-if="errorMessage") {{errorMessage}}
    v-card-text
      v-btn(color="blue darken-1", dark, block, @click="loginWithEntra", :loading="entraLoading")
        v-icon(left) mdi-microsoft
        | Microsoftでサインイン
      v-divider(class="my-4")
      .text-center.caption.grey--text.mb-2 または
      v-form
        v-text-field(prepend-icon="person", name="login", label="Login", type="text", v-model="modelLogin")
        v-text-field(prepend-icon="lock", name="password", label="Password", type="password", v-model="modelPassword")
    v-card-actions
      v-spacer
      v-btn(color="primary", @click="login") ログイン
</template>
<script>
import Param from "@/lib/definition/variables";
import { msalInstance, loginRequest } from "@/lib/msal-config";
export default {
  data() {
    return {
      site: Param.Site,
      modelLogin: null,
      modelPassword: null,
      entraLoading: false
    }
  },
  computed: {
    errorMessage () { return this.$store.state.Login.errorMessage }
  },
  methods: {
    async initialize () {
    },
    getTenantId () {
      var host = window.location.host
      var tenantId = 'jtechs'
      var component = host.split('.')
      if (component.length > 0 && host.includes('koosapp.com')) {
        tenantId = component[0]
      }
      if (component.length > 0 && host.includes('koosapp.azurewebsites.net')) {
        tenantId = 'jtechs'
      }
      if (component.length > 0 && host.includes('koosappapi.azurewebsites.net')) {
        tenantId = 'jtechs'
      }
      return tenantId
    },
    async login () {
      var tenantId = this.getTenantId()
      var param = { email: this.modelLogin, password: this.modelPassword, tenantId }
      await this.$store.dispatch('Login/login', param)
      if (this.$store.getters["Login/loggedIn"]){
        this.$router.push(this.site.deployFolder + "/")
      }
    },
    async loginWithEntra () {
      this.entraLoading = true
      try {
        await msalInstance.loginRedirect(loginRequest)
      } catch (error) {
        console.error('MSAL login error:', error)
        this.$store.commit('Login/SET_LOGIN_ERROR_MESSAGE', 'Microsoft認証の開始に失敗しました。')
        this.entraLoading = false
      }
    }
  },
  async mounted () {
    this.initialize()
  }
}
</script>